export default __webpack_public_path__ + "12866c006580e96b785404d43868e452.webp";